import React, { useState } from "react";
import { FRAMEWORKS, FUNNEL_SCENARIOS } from "./data.js";

export default function FunnelStage({ onComplete }) {
  const [index, setIndex] = useState(0);
  const [correctCount, setCorrectCount] = useState(0);
  const [picked, setPicked] = useState(null);

  const current = FUNNEL_SCENARIOS[index];
  const done = index >= FUNNEL_SCENARIOS.length;

  const choose = (frameworkId) => {
    if (picked) return;
    const correct = frameworkId === current.correct;
    if (correct) setCorrectCount((c) => c + 1);
    setPicked(frameworkId);
  };

  const advance = () => {
    setPicked(null);
    setIndex((i) => i + 1);
  };

  if (done) {
    return (
      <div className="animate-popIn text-center">
        <p className="label-pixel mb-2 text-gold">Funnel Complete</p>
        <h2 className="pixel-heading mb-4 text-base text-mist">Rambling, Distilled</h2>

        <div className="mx-auto mb-6 max-w-sm space-y-2 border-2 border-black bg-ink p-4 text-left text-sm">
          <div className="flex justify-between">
            <span className="text-mist/60">Right Framework</span>
            <span className="text-gold">
              {correctCount}/{FUNNEL_SCENARIOS.length}
            </span>
          </div>
        </div>

        <p className="mx-auto mb-6 max-w-sm text-xs text-mist/60">
          Rambling isn't a personality trait — it's just a thinking process shared out loud
          instead of a distilled message. A framework is the funnel that turns one into the
          other.
        </p>

        <button onClick={() => onComplete({ correctCount })} className="btn-magenta">
          ENTER THE ROOM ▶
        </button>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-4 flex items-center justify-between font-display text-[9px] text-mist/60">
        <span>THE FUNNEL</span>
        <span>
          {index}/{FUNNEL_SCENARIOS.length}
        </span>
      </div>

      <p className="mb-5 text-xs text-mist/60">Which framework actually fits this moment?</p>

      <div
        key={current.id}
        className={`mb-5 border-2 bg-ink p-6 text-center transition-colors ${
          picked ? (picked === current.correct ? "border-lime shadow-glow-cyan" : "border-danger") : "border-black"
        }`}
      >
        <p className="text-sm leading-relaxed text-mist/80">{current.text}</p>
      </div>

      {!picked ? (
        <div className="space-y-2">
          {FRAMEWORKS.map((fw) => (
            <button
              key={fw.id}
              onClick={() => choose(fw.id)}
              className="flex w-full items-center justify-between border-2 border-mist/30 px-4 py-3 text-left transition-colors hover:border-gold hover:text-gold"
            >
              <span className="font-display text-[9px] uppercase">{fw.label}</span>
              <span className="text-[11px] text-mist/50">{fw.subtitle}</span>
            </button>
          ))}
        </div>
      ) : (
        <div
          className={`animate-popIn border-2 p-4 text-center ${
            picked === current.correct ? "border-lime bg-lime/10 text-lime" : "border-danger bg-danger/10 text-danger"
          }`}
        >
          <p className="mb-1 font-display text-[9px] uppercase">
            {picked === current.correct
              ? "Right Framework"
              : `Not Quite — It Was ${FRAMEWORKS.find((f) => f.id === current.correct)?.label}`}
          </p>
          <p className="mb-3 text-xs text-mist/80">{current.explain}</p>
          <button onClick={advance} className="btn-cyan !text-[9px]">
            CONTINUE ▶
          </button>
        </div>
      )}
    </div>
  );
}
